import { useState, useEffect } from 'react';
import { seoService } from '../services/firebase';
import type { SEOSettings } from '../types';

export const useSEO = () => {
  const [seoSettings, setSeoSettings] = useState<SEOSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSEOSettings = async () => {
      try {
        setLoading(true);
        setError(null);
        const settings = await seoService.getSEOSettings();
        setSeoSettings(settings);
      } catch (err) {
        console.error('SEO ayarları yüklenirken hata:', err);
        setError('SEO ayarları yüklenemedi');
      } finally {
        setLoading(false);
      }
    };

    fetchSEOSettings();
  }, []);

  const refreshSEOSettings = async () => {
    try {
      setLoading(true);
      const settings = await seoService.getSEOSettings();
      setSeoSettings(settings);
    } catch (err) {
      setError('SEO ayarları yenilenemedi');
    } finally {
      setLoading(false);
    }
  };

  return {
    seoSettings,
    loading,
    error,
    refreshSEOSettings
  };
};

// SEO verilerini sayfaya göre getiren yardımcı fonksiyon
export const getPageSEO = (seoSettings: SEOSettings | null, pageName: keyof SEOSettings['pageSettings']) => {
  if (!seoSettings) return null;

  const pageSettings = seoSettings.pageSettings[pageName];
  return {
    title: pageSettings?.title || seoSettings.defaultTitle,
    description: pageSettings?.description || seoSettings.defaultMetaDescription,
    keywords: pageSettings?.keywords && pageSettings.keywords.length > 0 ? pageSettings.keywords : seoSettings.defaultMetaKeywords,
    ogTitle: pageSettings?.title || seoSettings.defaultTitle,
    ogDescription: pageSettings?.description || seoSettings.defaultMetaDescription,
    ogImage: seoSettings.openGraph?.defaultImage || seoSettings.twitterCard?.defaultImage || '',
    ogUrl: seoSettings.siteUrl,
    twitterTitle: pageSettings?.title || seoSettings.defaultTitle,
    twitterDescription: pageSettings?.description || seoSettings.defaultMetaDescription,
    twitterImage: seoSettings.twitterCard?.defaultImage || seoSettings.openGraph?.defaultImage || '',
  };
}; 